import React, { useEffect, useMemo, useState } from "react";
import {
  Grid,
  MobileStepper,
  Button,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import _ from "lodash";

const isDashboardCourseInactive = (isActive) => isActive === 0;

const DashboardForumCard = ({
  heading,
  description,
  user,
  list = [],
  onButtonClick = () => { },
  date,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

  const displayList = useMemo(() => {
    const raw =
      Array.isArray(list) && list.length > 0
        ? list
        : list && typeof list === "object"
          ? [list]
          : [];
    return raw.filter((item) => !isDashboardCourseInactive(item?.is_active));
  }, [list]);

  const maxSteps = displayList?.length;

  useEffect(() => {
    setActiveStep((prev) => {
      if (!displayList.length) return 0;
      return Math.min(prev, displayList.length - 1);
    });
  }, [displayList]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const onViewForum = (item) => {
    navigate("/forum-message", {
      state: { forumId: _.get(item, "id", ""), forum: item },
    });
  };

  return (
<Grid
container
flexDirection={"column"}
alignItems={"center"}
minHeight={403}
maxHeight={403}
flexWrap={'nowrap'}
justifyContent={'center'}
p={2}
>
<Grid item>
  <h3 style={{ fontWeight: 700,marginTop:15,color:"#9834F0"}}>New Threads</h3>
</Grid>

<Grid item sx={{ width: "100%",display:'flex',flexDirection:'column'}}>
{displayList.length === 0 ? (
      <Grid item maxHeight={330} minHeight={330} >
       <p
              style={{ textAlign: "center" ,marginTop:40}}
              className="dashboard-student-heading"
            >
              No Threads Available
            </p>
      </Grid>
    ) : (
  <SwipeableViews
    axis={"x"}
    index={activeStep}
    onChangeIndex={handleStepChange}
    enableMouseEvents
    style={{
      backgroundColor: "#ffffff",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    
    {displayList.map((item, index) => {
      return (
        <Grid
          key={item?.id ?? index}
          container
          flexDirection={"column"}
          alignItems={"center"}
        >
          <Grid item marginTop={4}>
            <p
              style={{ textAlign: "center" }}
              className="dashboard-student-heading"
            >
              {_.get(item, "name", "")}
            </p>
          </Grid>
          <Grid item maxHeight={200} minHeight={200} overflow={'hidden'}>
          {(item?.forums || []).map((val, forumIndex) => {
                      return (
                          <div key={val?.id ?? forumIndex} style={{display:'flex',flexDirection:'column',justifyContent:'center',cursor: "pointer",paddingInline:30,marginBottom:2}}   onClick={() => onViewForum(val)}>
                             <p className="forum-card-heading-x">{val.name}</p>
                             <span className="forum-card-description-x">{val.description}</span>
    
                           <Divider variant="middle" />
                           </div>
                      )
                     })
                   }
          </Grid>
 

          <Grid item sx={{ width: "100%" }}>
            <MobileStepper
              steps={maxSteps}
              position="static"
              activeStep={activeStep}
              nextButton={
                <Button
                  size="small"
                  onClick={handleNext}
                  disabled={activeStep === maxSteps - 1}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#ffffff !important",
                      color: "#28b882 !important",
                      boxShadow: "10px !important",
                    },
                  }}
                >
                  {/* Next */}
                  {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                  ) : (
                    <KeyboardArrowRight />
                  )}
                </Button>
              }
              backButton={
                <Button
                  sx={{
                    "&:hover": {
                      backgroundColor: "#ffffff !important",
                      color: "#28b882 !important",
                      boxShadow: "10px !important",
                    },
                  }}
                  size="small"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                >
                  {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                  ) : (
                    <KeyboardArrowLeft />
                  )}
                  {/* Back */}
                </Button>
              }
            />
          </Grid>
        </Grid>
      );
    })}
  </SwipeableViews>
    )
  }
</Grid>
</Grid>
  );
};

export default DashboardForumCard;
